export default "__VITE_ASSET__DOlh56c1__"